import type { DSData } from 'webapp-types';

import type DsDataOutputBase from 'webapp/models-custom/ds-data/output/base';

export default abstract class DsDataPointBase {
	abstract output: DsDataOutputBase;

	value: number;
	valueStr: string;

	constructor(rawData: DSData.Point) {
		this.value = rawData.value;
		this.valueStr = rawData.valueStr;
	}

	get hasValue() {
		return typeof this.value === 'number';
	}

	get format() {
		return this.output.format;
	}

	get scale() {
		return this.output.scale;
	}

	get invert() {
		return this.output.invert;
	}
}
